import {
  AllBuyerConfigSettings,
  BuyerConfig,
} from '../../../../shared/interfaces/buyer-config.interface';
import { CompanyAndFeature } from '../../../../shared/interfaces/buyer-config.interface';
import { NO_COMPANY } from './config-enable.constants';

export class Configuration {
  static extract(config: string | CompanyAndFeature): CompanyAndFeature {
    if (typeof config === 'string') {
      return {
        companyId: 0,
        configSetting: config,
      };
    }
    return {
      companyId: config.companyId,
      configSetting: config.configSetting,
    };
  }
}

export class Enable {
  userType: string;
  config: CompanyAndFeature;
  constructor(userType: string, config: CompanyAndFeature) {
    this.userType = userType;
    this.config = config;
  }
  handle(allBuyerConfigs: AllBuyerConfigSettings, orElse: BuyerConfig) {
    if (this.userType === 'buyer') {
      if (this.config.companyId === NO_COMPANY) {
        return false;
      }
      return this.isConfigEnabledBuyer(
        this.config.configSetting as keyof BuyerConfig,
        orElse
      );
    }
    return this.isConfigEnabledOperator(
      this.config.configSetting as keyof AllBuyerConfigSettings,
      allBuyerConfigs
    );
  }

  isConfigEnabledBuyer(
    configSetting: keyof BuyerConfig,
    buyerConfig: BuyerConfig
  ) {
    return [configSetting].some(
      (configSetting: keyof BuyerConfig) => buyerConfig[configSetting]
    );
  }

  isConfigEnabledOperator(
    configSetting: keyof AllBuyerConfigSettings,
    allBuyerConfigs: AllBuyerConfigSettings
  ) {
    if (!allBuyerConfigs || !allBuyerConfigs[configSetting]?.length) {
      return false;
    }
    const result = allBuyerConfigs[configSetting].findIndex(
      (companyId: number) => companyId === this.config.companyId
    );
    if (result < 0) {
      return false;
    }
    return true;
  }
}
